import { render, staticRenderFns } from "./pueGaugeChart.vue?vue&type=template&id=13db1351&scoped=true&"
import script from "./pueGaugeChart.vue?vue&type=script&lang=js&"
export * from "./pueGaugeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13db1351",
  null
  
)

export default component.exports